String.prototype.ekopris = function() {
    var str = this;
    str = str.toString();
    var num = parseInt(str);
    //console.log("CDI Pris : " + num);

    if(num > 79999999900) {
        num = 100000000000 - num;
        str = "-" + num.toString();
    }
    else str = num.toString();

    if(str.length > 2) str = str.substr(0, (str.length - 2)) + "." + str.substr((str.length - 2), 2);
    if(str.length > 6) str = str.substr(0, (str.length - 6)) + "" + str.substr((str.length - 6));

    return str;
}

String.prototype.toswe = function() {
    var sv = this;
    sv = sv.replace(/\|/g, "ö");
    sv = sv.replace(/\#/g, "Ö");
    sv = sv.replace(/\\/g, "Ö");
    sv = sv.replace(/\{/g, "ä");
    sv = sv.replace(/\[/g, "Ä");
    sv = sv.replace(/\}/g, "å");
    sv = sv.replace(/\]/g, "Å");
    sv = sv.replace(/�/g, "Ö"); // Map '�' to 'Ö'
    sv = sv.replace(/\s+$/, ""); // Remove trailing whitespace
    return sv;
};

const BASE_URL = "https://kvitto.spaider.se/api";

async function apiCall(body, endPoint) {
    console.log(JSON.stringify(body));
    const fullUrl = `${BASE_URL}/${endPoint}`
    console.log(fullUrl)

    try {
        const response = await fetch(fullUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(body)
        });

        if (!response.ok) {
            const errorText = await response.text();
            console.error("Server error:", errorText);
            return null;
        }

        const data = await response.json();
        console.log("Response:", data);
        return data;
    } catch (error) {
        console.error("Fetch error:", error);
        return null;
    }
}

export async function getOrder(sid = "S0002462", datum, order, check) {
    const body = {
        sid,
        datum,
        order,
        check
    };

    console.log("Sending:", body);

    return await apiCall(body, "order");
}

export async function getNota(sid, datum, nota, check){
    const body = {
        sid, datum, nota, check
    }

    console.log("Sending:", body);

    return await apiCall(body, "nota");
}

export async function getFNota(sid, datum, nota, check){
    const body = {
        sid, datum, nota, check
    }

    return await apiCall(body, "Fnota")
}

